import React from 'react';
import { Star } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
const avatars = ['https://cdn.magicpatterns.com/patterns/generated-images/8dada07c-119c-44da-9e87-37724df638c3.jpg', 'https://cdn.magicpatterns.com/patterns/generated-images/ac941a17-7e04-4ce1-818a-7c61fe7df44f.jpg', 'https://cdn.magicpatterns.com/patterns/generated-images/5656d277-7a19-49e3-a23f-523c23b7d62f.jpg'];
function GoogleLogo() {
  return <svg viewBox="0 0 48 48" aria-hidden="true" className="h-4 w-4 shrink-0" data-id="element-194" data-mp="3gy1vx3fdbrc">
      <path fill="#4285F4" d="M45.12 24.5c0-1.56-.14-3.06-.4-4.5H24v8.51h11.84c-.51 2.75-2.06 5.08-4.39 6.64v5.52h7.11c4.16-3.83 6.56-9.47 6.56-16.17z" data-id="element-195" data-mp="8detx2dqwa9p" />
      <path fill="#34A853" d="M24 46c5.94 0 10.92-1.97 14.56-5.33l-7.11-5.52c-1.97 1.32-4.49 2.1-7.45 2.1-5.73 0-10.58-3.87-12.31-9.07H4.34v5.7C7.96 41.07 15.4 46 24 46z" data-id="element-196" data-mp="3ushclczg6fbq" />
      <path fill="#FBBC05" d="M11.69 28.18A13.2 13.2 0 0 1 11 24c0-1.45.25-2.86.69-4.18v-5.7H4.34A21.99 21.99 0 0 0 2 24c0 3.55.85 6.91 2.34 9.88l7.35-5.7z" data-id="element-197" data-mp="r4pj9f3toezh" />
      <path fill="#EA4335" d="M24 10.75c3.23 0 6.13 1.11 8.41 3.29l6.31-6.31C34.91 4.18 29.93 2 24 2 15.4 2 7.96 6.93 4.34 14.12l7.35 5.7C13.42 14.62 18.27 10.75 24 10.75z" data-id="element-198" data-mp="1pba09caw8iwd" />
    </svg>;
}
export function SocialProof() {
  const {
    t
  } = useLanguage();
  return <div className="flex flex-col items-center justify-center gap-2 text-[13px] text-grey-800-lock sm:flex-row sm:gap-5" data-id="element-199" data-mp="2d0chij1m89qc">
      <p className="flex items-center gap-2.5 rounded-full bg-white/70 py-1.5 pl-1.5 pr-3.5" data-id="element-200" data-mp="28215c1nuln4y">
        <span className="flex -space-x-2" aria-hidden="true" data-id="element-201" data-mp="2mz1v3zmhb80s">
          {avatars.map(src => <img key={src} src={src} alt="" loading="lazy" className="h-7 w-7 rounded-full border-2 border-white object-cover" data-id="element-202" data-mp="2hyvzk8d391df" />)}
        </span>
        <span data-id="element-203" data-mp="nmz7cd6tnrhb">
          {t.socialProof.usedBy}{' '}
          <span className="font-semibold text-blue-reways-950-lock" data-id="element-204" data-mp="1da1v70jtd1e4">{t.socialProof.managers}</span>
        </span>
      </p>

      <p className="flex items-center gap-2" data-id="element-205" data-mp="1hc6mhsmshlxl">
        <span className="flex items-center gap-0.5" aria-hidden="true" data-id="element-206" data-mp="1hcyih4katloe">
          {Array.from({
          length: 5
        }).map((_, i) => <Star key={i} className="h-3.5 w-3.5 fill-[#f8a400] text-[#f8a400]" data-id="element-207" data-mp="1r9uj6o3yh3ie" data-mpi={i} />)}
        </span>
        <span className="font-semibold text-blue-reways-950-lock" data-id="element-208" data-mp="1w97hq646vz0t">5.0</span>
        <span className="flex items-center gap-1" data-id="element-209" data-mp="209zngpdurlsc">
          {t.socialProof.on} <GoogleLogo data-id="element-210" data-mp="207wqflea8se4" /> Google
        </span>
      </p>
    </div>;
}